import * as React from "react";
import { observer } from "mobx-react";

import { CarsFormHotwireView } from "../components/CarsFormView/CarsFormHotwireView";
import { WizardCarPWAViewProps } from "../typings";

export const WizardCarPWAHotwireView: React.FunctionComponent<WizardCarPWAViewProps> = observer(
  ({
    flexComponent,
    isDiffDropOff,
    onDifferentDropOffSelected,
    setIsDifferentDropOff,
    wizardState,
    setInputsRefs,
    getLocError,
  }) => {
    const {
      globalWizardState,
      carWizardState,
      carWizardState: { config: carConfig },
    } = wizardState;
    const globalConfig = globalWizardState.config;
    const actionForm = carConfig.form.action;

    return (
      <form
        noValidate={true}
        action={actionForm}
        autoComplete="off"
        className="WizardCarPWA"
        id={carConfig.elementId}
        data-fm={flexComponent.fmId}
        data-fm-title-id={flexComponent.fmTitleId}
        data-module="searchCarForm"
        onSubmit={carWizardState.submit}
      >
        <CarsFormHotwireView
          setInputsRefs={setInputsRefs}
          carWizardState={carWizardState}
          carConfig={carConfig}
          onDifferentDropOffSelected={onDifferentDropOffSelected}
          setIsDifferentDropOff={setIsDifferentDropOff}
          isDiffDropOff={isDiffDropOff}
          getLocError={getLocError}
          globalConfig={globalConfig}
        />
      </form>
    );
  }
);

export default WizardCarPWAHotwireView;
